import { useContext } from "react";
import { CustomerDataContext } from "@/providers/CustomerDataContext";

export const useTradingAccounts = () => {
  const { data: customerData, ...queryResult } =
    useContext(CustomerDataContext);

  return {
    data: customerData.accounts,
    ...queryResult,
  };
};
